// Shared Zgharta and Bsharri village registers.
//
// Canonical source for census import and weekly event ingest. Ownership, aliases, and
// ambiguity live here so the two writers cannot drift. North Lebanon is not caza evidence.

export const CAZA_ZGHARTA = 'zgharta';
export const CAZA_BSHARRI = 'bsharri';
export const DISTRICT_VILLAGE_NAMES = Object.freeze(['Bsharri', 'Zgharta']);

export function normalizeLocalityKey(value) {
  return String(value == null ? '' : value)
    .normalize('NFKD')
    .replace(/[\u0300-\u036f\u064b-\u065f\u0670]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\u0600-\u06ff]+/g, ' ')
    .trim();
}

// Zgharta District villages, transcribed from the district table and the DGLAC register.
// `ambiguous` marks a name that a village in another caza also carries. Census import still
// matches those names exactly; event ingest requires independent same-caza evidence.
export const ZGHARTA_VILLAGE_DEFINITIONS = Object.freeze([
  { name: 'Zgharta', caza: CAZA_ZGHARTA, aliases: ['Zghorta', 'Zgharta Ehden', 'Zgharta-Ehden', 'Zgharta Caza', 'Zgharta District', 'زغرتا', 'زغرتا اهدن'] },
  { name: 'Ehden', caza: CAZA_ZGHARTA, aliases: ['Ahden', 'Ehdene', 'Ehdin', 'اهدن', 'إهدن', 'أهدن'] },
  { name: 'Aarbet Qozhaya', caza: CAZA_ZGHARTA, aliases: ['Arbet Kozhaya', 'Arbet Qozhaya', 'Aarbet Qouzhaiya', 'Arbaat Qazhya', 'Qozhaya', 'Qozhaiya'] },
  { name: 'Aachach', caza: CAZA_ZGHARTA, aliases: ['Achach', 'Ashash', 'Achache'] },
  { name: 'Aintourine', caza: CAZA_ZGHARTA, aliases: ['Ain Tourine', 'Aaintourine', 'Aintourin'] },
  { name: 'Aito', caza: CAZA_ZGHARTA, aliases: ['Aitou', 'Aytou', 'Ayto'] },
  { name: 'Aarjes', caza: CAZA_ZGHARTA, aliases: ['Arjess', 'Arjish', 'Aarjess'] },
  { name: 'Ardeh', caza: CAZA_ZGHARTA, aliases: ['Ardah', 'Aardeh', 'Aardat', 'Arde', 'ارده', 'أرده'] },
  { name: 'Aslout', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Asnoun', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Basloukit', caza: CAZA_ZGHARTA, aliases: ['Baslouqit', 'Basliqit'] },
  { name: 'Bchennine', caza: CAZA_ZGHARTA, aliases: ['Bishnin', 'Bchannine'] },
  { name: 'Beit Aouker', caza: CAZA_ZGHARTA, aliases: ['Beit Awkar', 'Beit Okar'] },
  { name: 'Beit Obeid', caza: CAZA_ZGHARTA, aliases: ['Beit Abid'] },
  { name: 'Besbeel', caza: CAZA_ZGHARTA, aliases: ['Sebaal', 'Besebaal', 'Sebhel', 'Bassbaal'] },
  { name: 'Bhairet Toula', caza: CAZA_ZGHARTA, aliases: ['Bhayri'] },
  { name: 'Bnachii', caza: CAZA_ZGHARTA, aliases: ['Bnachei', 'Bnachee', 'Banshie', 'Bneshaai'] },
  { name: 'Bousit', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Ejbeh', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Fraydiss', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Haret El Fouar', caza: CAZA_ZGHARTA, aliases: ['Haret Al Fawar', 'Harat Al Fawar', 'Haref El Fouar'] },
  { name: 'Harf Ardeh', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Harf Miziara', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Hawqa', caza: CAZA_ZGHARTA, aliases: ['Haouqa', 'Houqa', 'Hawka', 'Haouka', 'حوقا'] },
  { name: 'Hilan', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Houmeiss', caza: CAZA_ZGHARTA, aliases: ['Hmaiss', 'Hmayss'] },
  { name: 'Iaal', caza: CAZA_ZGHARTA, aliases: ['Ayal'] },
  { name: 'Karahbache', caza: CAZA_ZGHARTA, aliases: ['Qarah Bach', 'Korah Bach', 'Karah Bach'] },
  { name: 'Karm Saddeh', caza: CAZA_ZGHARTA, aliases: ['Karmsaddeh', 'Karem Saddeh'] },
  { name: 'Kfardlakos', caza: CAZA_ZGHARTA, aliases: ['Kfar Dlaqous', 'Kfard Lakouss'] },
  { name: 'Kfarfou', caza: CAZA_ZGHARTA, aliases: ['Kfar Fou', 'Kfardfou'] },
  { name: 'Kfarhata', caza: CAZA_ZGHARTA, aliases: ['Kfar Hata'] },
  { name: 'Kfarsghab', caza: CAZA_ZGHARTA, aliases: ['Kfar Sghab', 'Kfaresghab', 'كفرصغاب'] },
  { name: 'Kfaryachit', caza: CAZA_ZGHARTA, aliases: ['Kfar Yachit'] },
  { name: 'Kfar Zeina', caza: CAZA_ZGHARTA, aliases: ['Kfar Zina', 'Kfarzina', 'Kferzeina', 'Kfarzayna'] },
  { name: 'Mazraat El Teffah', caza: CAZA_ZGHARTA, aliases: ['Mazraat Al Tuffah', 'Mazraat Et Teffah'] },
  { name: 'Mazraat El Nahr', caza: CAZA_ZGHARTA, aliases: ['Mazraat Al Nahr'] },
  { name: 'Mejdlaya', caza: CAZA_ZGHARTA, aliases: ['Majdlaiya', 'Majdlaya', 'Majdalia', 'Mejdlaiya', 'مجدليا'] },
  { name: 'Miryata', caza: CAZA_ZGHARTA, aliases: ['Miriata'] },
  { name: 'Miziara', caza: CAZA_ZGHARTA, aliases: ['Mziara', 'Mezyara', 'مزيارة'] },
  { name: 'Morh Kfarsghab', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Qadrieh', caza: CAZA_ZGHARTA, aliases: ['Kadrieh', 'Qadriyeh'] },
  { name: 'Rachiine', caza: CAZA_ZGHARTA, aliases: ['Racheine', 'Rachine', 'Rachaaine'] },
  { name: 'Raskifa', caza: CAZA_ZGHARTA, aliases: ['Ras Kifa'] },
  { name: 'Saraal', caza: CAZA_ZGHARTA, aliases: ['Seraal', 'Serhel', 'Sereel'] },
  { name: 'Tallet Zgharta', caza: CAZA_ZGHARTA, aliases: [] },
  { name: 'Sakhra', caza: CAZA_ZGHARTA, aliases: [], ambiguous: 'a Sakhra also exists in Keserwan' },
  { name: 'Alma', caza: CAZA_ZGHARTA, aliases: [], ambiguous: 'Alma ech Chaab is in South Lebanon' },
  { name: 'Daraya', caza: CAZA_ZGHARTA, aliases: ['Darya'], ambiguous: 'Daraya names towns outside this caza too' },
  { name: 'Jdaydeh', caza: CAZA_ZGHARTA, aliases: ['Jdeideh'], ambiguous: 'Jdeideh is a large Beirut suburb' },
  { name: 'Toula', caza: CAZA_ZGHARTA, aliases: [], ambiguous: 'a Toula also exists in Batroun caza' },
]);

// 22 Bsharri-caza localities from docs/research/2026-08-24-bsharri-village-register.md
// (21 MoI register towns plus Al Arz / the Cedars). Bane is bsharri.
export const BSHARRI_VILLAGE_DEFINITIONS = Object.freeze([
  { name: 'Bsharri', caza: CAZA_BSHARRI, aliases: ['Bcharre', 'Bcharreh', 'Becharre', 'Bcharri', 'Bicherri', 'Bsharre', 'بشري'] },
  {
    name: 'Al Arz',
    caza: CAZA_BSHARRI,
    aliases: [
      'Ariz',
      'El Arz',
      'El-Arz',
      'Al-Arz',
      'Cedars',
      'The Cedars',
      'Cedres',
      'Cèdres',
      'Les Cedres',
      'Les Cèdres',
      'أرز',
      'الأرز',
    ],
  },
  { name: 'Bqaa Kafra', caza: CAZA_BSHARRI, aliases: ['Beqaa Kafra', 'Bqaakafra', 'Bekaa Kafra', "Bqa'kafra", 'بقاعكفرا'] },
  { name: 'Hadath El Jebbeh', caza: CAZA_BSHARRI, aliases: ['Hadath el-Joubbeh', 'Hadeth el Jebbe', 'Hadath al-Jubba', 'Hadet ej Jebbeh', 'حدث الجبة'] },
  { name: 'Hasroun', caza: CAZA_BSHARRI, aliases: ['Hasroune', 'Hassroun', 'Hasrun', 'Hasrûn', 'حصرون'] },
  { name: 'Hadchit', caza: CAZA_BSHARRI, aliases: ['Hadshit', 'Hadchite', 'Hadsheet', 'حدشيت'] },
  { name: 'Bazoun', caza: CAZA_BSHARRI, aliases: ['Bazaoun', 'Bzaaoun', "Baz'un", 'بزعون'] },
  { name: 'Bqarqacha', caza: CAZA_BSHARRI, aliases: ['Bkarqasha', 'Bqerqacha', 'Bkerkacha', 'Bkrkasha', 'Baqarqasha', 'بقرقاشا'] },
  { name: 'Qnat', caza: CAZA_BSHARRI, aliases: ['Qnaat', 'Qannat', 'Qanat', 'Kannat', 'قنات'] },
  { name: 'Tourza', caza: CAZA_BSHARRI, aliases: ['Torza', 'Turza', 'طورزا'] },
  { name: 'Aabdine', caza: CAZA_BSHARRI, aliases: ['Abdine', 'Abdeen', 'Abdin', "'Abdin", 'عبدين'] },
  { name: 'Bane', caza: CAZA_BSHARRI, aliases: ['Ban', 'Bann', 'Baan', 'بان'] },
  { name: 'Dimane', caza: CAZA_BSHARRI, aliases: ['Diman', 'Deiman', 'Al-Diman', 'Ad-Dimane', 'الديمان'] },
  { name: 'Blaouza', caza: CAZA_BSHARRI, aliases: ['Blawza', 'Blauza', 'Blouza', 'Bluza', 'بلوزا'] },
  { name: 'Barhalioun', caza: CAZA_BSHARRI, aliases: ['Barhalyoun', 'Berhalioun', 'Barhelioun', 'Barhaliyon', 'برحليون'] },
  { name: 'Brissat', caza: CAZA_BSHARRI, aliases: ['Brisat', 'Braissat', 'Breissat', 'Braysat', 'بريسات'] },
  { name: 'Beit Menzer', caza: CAZA_BSHARRI, aliases: ['Beit Minzer', 'Beit Mounzer', 'Beit Mendar', 'Bayt Mundhir', 'بيت منذر'] },
  { name: 'Qnaywer', caza: CAZA_BSHARRI, aliases: ['Qnaiouer', 'Qnaywar', 'Kniouar', 'Qaniore', 'Qaniour', 'قنيور'] },
  { name: 'Mazraat Assaf', caza: CAZA_BSHARRI, aliases: ['Mazraa Assaf', "Mazra'at 'Assaf", 'Mazraat Aassaf', 'Mazraa Aassaf', 'مزرعة عساف'] },
  { name: 'Mazraat Bani Saab', caza: CAZA_BSHARRI, aliases: ['Mazraa Bani Saab', "Mazra'at Bani Sa'b", 'Bani Saab', 'مزرعة بني صعب'] },
  { name: 'Wadi Qannoubine', caza: CAZA_BSHARRI, aliases: ['Wadi Qannubin', 'Ouadi Qannoubine', 'Wadi Kannoubine', 'Qannoubine', 'Annoubine', 'وادي قنوبين'] },
  { name: 'El Moghr wa Bla', caza: CAZA_BSHARRI, aliases: ['Al-Moghr wa Bla', 'Moghr El Ahwal', 'Mogher el Ahwal', 'Billa', 'Bella', 'Bla', 'المغر وبلا'] },
]);

export const SUPPORTED_VILLAGE_DEFINITIONS = Object.freeze([
  ...ZGHARTA_VILLAGE_DEFINITIONS,
  ...BSHARRI_VILLAGE_DEFINITIONS,
]);

const OWNER_LOOKUP = new Map();
const CROSS_REGISTER_COLLISIONS = [];

function rememberOwner(definition) {
  for (const label of [definition.name, ...(definition.aliases || [])]) {
    const key = normalizeLocalityKey(label);
    if (!key) continue;
    const existing = OWNER_LOOKUP.get(key);
    if (existing && existing.caza !== definition.caza) {
      CROSS_REGISTER_COLLISIONS.push({
        key,
        villages: [existing.village, definition.name],
        cazas: [existing.caza, definition.caza],
      });
      continue;
    }
    OWNER_LOOKUP.set(key, {
      village: definition.name,
      caza: definition.caza,
      ambiguous: Boolean(definition.ambiguous),
    });
  }
}

ZGHARTA_VILLAGE_DEFINITIONS.forEach(rememberOwner);
BSHARRI_VILLAGE_DEFINITIONS.forEach(rememberOwner);

export const CROSS_REGISTER_KEY_COLLISIONS = Object.freeze(CROSS_REGISTER_COLLISIONS);

export function matchVillageOwner(text) {
  const key = normalizeLocalityKey(text);
  if (!key) return null;
  return OWNER_LOOKUP.get(key) || null;
}

export function isDistrictVillageName(village) {
  return DISTRICT_VILLAGE_NAMES.includes(village);
}

export function villageOwnerLookupEntries() {
  return Array.from(OWNER_LOOKUP.entries()).map(([key, owner]) => ({ key, ...owner }));
}
